import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { CLIENT_BRAND_CREATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_client_create_brand = (data) => {
    return (dispatch, getState) => {

        Auth.currentSession().then((session) => {

        const token = session && session.idToken.jwtToken;

        var config = { headers: { Authorization: 'Bearer ' + token } };

        return axios.post(`${Config.API_BASE_URL}/client/brand`, data, config)
            .then(response => {

                dispatch({
                    type: CLIENT_BRAND_CREATE,
                    payload: {
                        ...response.data,
                        errors: {},
                        task: {
                            result: true
                        }
                    }
                });

            })
            .catch(error => {

                dispatch({
                    type: CLIENT_BRAND_CREATE,
                    payload: {
                        errors: {...error.response.data},
                        task: {
                            result: false
                        }
                    }
                });
            });
}).catch(error => { 
 dispatch({ type: EXPIRED }); 
 }); 
 };
}

export default api_client_create_brand;